import { AssetSimpleResponse, EImageToVideoMode } from 'api/core';
import { twMerge } from 'tailwind-merge';

interface ImageToVideoPreviewProps {
  asset: AssetSimpleResponse;
  mode: EImageToVideoMode;
}

export const ImageToVideoPreview = ({
  asset,
  mode,
}: ImageToVideoPreviewProps) => {
  return (
    <div className="overflow-hidden relative w-full max-h-64 flex flex-col gap-4">
      <img
        src={asset.url}
        alt={asset.originalFileName}
        className={twMerge(
          'object-contain w-full h-48',
          mode === EImageToVideoMode.PanLeftToRight && 'animate-panRight',
          mode === EImageToVideoMode.ZoomIn && 'animate-panZoomIn',
          mode === EImageToVideoMode.ZoomOut && 'animate-panZoomOut',
          mode === EImageToVideoMode.PanTopLeftToBottomRight &&
            'animate-panDiagonal',
          mode === EImageToVideoMode.Still && ''
        )}
      />
      {mode !== EImageToVideoMode.Automatic &&
      mode !== EImageToVideoMode.Still ? (
        <p className="text-red-500 text-sm text-center">
          Forhåndsvisningen er vejledende, så det endelige resultat kan variere.
        </p>
      ) : null}
    </div>
  );
};
